import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const quickCategories = categories.slice(0, 8);

  return (
    <footer className="bg-foreground-900 text-background-200">
      {/* Upper section */}
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Column 1: Brand */}
          <div>
            <Link
              to="/"
              className="inline-block font-heading text-xl md:text-2xl font-bold text-background-50 hover:text-primary-400 transition-colors duration-200 mb-4"
            >
              superbuy<span className="text-primary-400">.baby</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mt-3 max-w-xs">
              Your trusted source for the best Superbuy spreadsheet collections, product sourcing guides, and international shopping tips. Updated daily for 2026.
            </p>
          </div>

          {/* Column 2: Newsletter */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-300 mb-4">
              Stay Updated
            </h4>
            <p className="text-sm text-foreground-300 mb-3">
              Get the latest Superbuy spreadsheet updates and product finds.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm text-primary-400 hover:text-primary-300 transition-colors font-medium cursor-pointer"
            >
              Visit Kaspreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          {/* Column 3: Quick Categories */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-300 mb-4">
              Popular Categories
            </h4>
            <ul className="space-y-2.5">
              {quickCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Resources */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-background-300 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/superbuy-spreadsheet-guide"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Spreadsheet Guide 2026
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-safe-shopping-tips"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Safety Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-qc-inspection-guide"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  QC Inspection Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-shipping-cost-guide"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-best-sneaker-spreadsheet"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Sneaker Spreadsheet
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-streetwear-spreadsheet"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Streetwear Guide
                </Link>
              </li>
              <li>
                <Link
                  to="/superbuy-size-conversion-guide"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  Size Conversion Guide
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower branding bar */}
      <div className="border-t border-foreground-700/30">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} Superbuy Baby. All rights reserved.
            </p>
            <p className="text-xs text-foreground-500">
              Affiliate Disclosure: Some links may earn us a commission at no extra cost to you.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}